import Markdown from 'react-markdown';
import Typography from '@material-ui/core/Typography';
import dedent from 'dedent';
import PropTypes from 'prop-types';

const headingLevelsToVariants = {
  1: 'h5',
  2: 'h6',
  3: 'subtitle1',
  default: 'subtitle1',
};

const HeadingRenderer = ({ level, children }) => (
  <Typography variant={headingLevelsToVariants[level] || headingLevelsToVariants.default}>
    {children}
  </Typography>
);

HeadingRenderer.propTypes = {
  level: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export const CustomMarkdown = ({ text }) => {
  const str = dedent(text);
  return <Markdown components={{ heading: HeadingRenderer }}>{str}</Markdown>;
};
CustomMarkdown.propTypes = {
  text: PropTypes.string.isRequired,
};
